// import Vue from 'vue';
import Vuex from 'vuex';
// import createPersistedState from 'vuex-persistedstate';
import analysis from './modules/analysis';
import documents from './modules/documents';
import user from './modules/user';

// Global definition of Vue in bootstrap.js was causing issues, so import of Vue and Vue.use(Vuex) were removed
// Vue.use(Vuex);

// Use a reducer function to only persist certain items
const reducer = state => {
  const { analysis, documents, user } = state;
  return {
    analysis: {
      draft: analysis.draft
    }
  }
};

// Create vuex store
export default new Vuex.Store({
  // plugins: [
  //   createPersistedState({
  //     key: 'myLab',
  //     reducer
  //   })
  // ],
  modules: {
    analysis,
    documents,
    user
  }
});


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/index.js